<template>
    <div>
        <section class="container mt-3 py-3">
            <!-- COMPONENTE TIPOGRAFIA-->
            <h4>Tipografía</h4>
            <div class="my-2 ms-3 mt-4">
                <h5>Titulos</h5>
                <p class="text-dark my-0">Diferentes titulos existentes en el sitio.</p>
                <div class="px-3 mt-4">
                    <p class="headline-1 m-0 p-0">Headline 1</p>
                    <p class="montserrat-bold-38">Montserrat Bold 38</p>

                    <p class="headline-2 m-0 p-0">Headline 2</p>
                    <p class="inter-light-38">Inter Light 38</p>

                    <p class="headline-3 m-0 p-0">Headline 3</p>
                    <p class="inter-semibold-32">Inter Semibold 32</p>

                    <p class="headline-4 m-0 p-0">Headline 4</p>
                    <p class="montserrat-regular-32">Montserrat Regular 32</p>

                    <p class="headline-5 m-0 p-0">Headline 5</p>
                    <p class="montserrat-light-32">Montserrat Light 32</p>

                    <p class="headline-6 m-0 p-0">Headline 6</p>
                    <p class="inter-bold-26 m-0 p-0">Inter Bold 26</p>

                </div>
            </div>
            <!-- CODIGO QUE SE MUESTRA -->
            <div class="p-3 bg-white" v-highlight><pre class="language-html p-0"><code><script type="text/plain" class="language-markup"><p class="headline-1">Headline 1</p>
<p class="montserrat-bold-38">Montserrat Bold 38</p>

<p class="headline-2">Headline 2</p>
<p class="inter-light-38">Inter Light 38</p>

<p class="headline-3">Headline 3</p>
<p class="inter-semibold-32">Inter Semibold 32</p>

<p class="headline-4">Headline 4</p>
<p class="montserrat-regular-32">Montserrat Regular 32</p>

<p class="headline-5">Headline 5</p>
<p class="montserrat-light-32">Montserrat Light 32</p>

<p class="headline-6">Headline 6</p>
<p class="inter-bold-26">Inter Bold 26</p>
</script></code></pre>
            </div>
            <!-- CODIGO HTML -->

        </section>

        <section class="container">
             <div class="my-2 ms-3">
                <h5>Texto cuerpo</h5>
                <p class="text-dark my-0">Diferentes textos para el contenido del sitio.</p>
                <div class="px-3 mt-3">
                    <p class="body-1 m-0 p-0">Body 1</p>
                    <p class="inter-bold-18">Inter Bold 18</p>

                    <p class="body-2 m-0 p-0">Body 2</p>
                    <p class="montserrat-medium-18">Montserrat Medium 18</p>

                    <p class="body-3 m-0 p-0">Body 3</p>
                    <p class="montserrat-medium-16">Montserrat Medium 16</p>

                    <p class="extra-text m-0 p-0">Extra text </p>
                    <p class="inter-bold-16">Inter Bold 16</p>
                </div>
            </div>
            <!-- CODIGO QUE SE MUESTRA -->
<div class="p-3 bg-white" v-highlight><pre class="language-html p-0"><code><script type="text/plain" class="language-markup"><p class="body-1">Body 1</p>
<p class="inter-bold-18">Inter Bold 18</p>

<p class="body-2">Body 2</p>
<p class="montserrat-medium-18">Montserrat Medium 18</p>

<p class="body-3">Body 3</p>
<p class="montserrat-medium-16">Montserrat Medium 16</p>

<p class="extra-text">Extra text </p>
<p class="inter-bold-16">Inter Bold 16</p>
</script></code></pre>
            </div>
            <!-- CODIGO HTML -->
        </section>
        <section class="container py-3">
             <div class="my-2 ms-3">
                <h5>Color de texto</h5>
                <p class="text-dark my-0">Diferentes colores de texto basado en la paleta de colores SIAHE.</p>
                <div class="px-3 mt-3">
                    <p class="text-primary-sh mb-0 p-0 ps-2">text-primary-sh </p>
                    <p class="text-primary-variant mb-0 p-0 ps-2">text-primary-variant</p>
                    <p class="text-secondary-sh mb-0 p-0 ps-2">text-secondary-sh</p>
                    <p class="text-secondary-variant mb-0 p-0 ps-2">text-secondary-variant</p>
                    <p class="text-tertiary mb-0 p-0 ps-2">text-tertiary</p>
                    <p class="text-tertiary-variant mb-0 p-0 ps-2">text-tertiary-variant</p>
                    <p class="text-siahe bg-dark mb-0 p-0 ps-2">text-siahe</p>
                    <p class="text-surface mb-0 p-0 ps-2">text-surface</p>
                    <p class="text-surface-variant mb-0 p-0 ps-2">text-surface-variant</p>
                    <p class="text-sucess-sh mb-0 p-0 ps-2">text-sucess-sh</p>
                    <p class="text-sucess-variant-sh mb-0 p-0 ps-2">text-sucess-variant-sh</p>
                    <p class="text-warning-sh mb-0 p-0 ps-2">text-warning-sh</p>
                    <p class="text-warning-variant-sh mb-0 p-0 ps-2">text-warning-variant-sh</p>
                    <p class="text-danger-sh mb-0 p-0 ps-2">text-danger-sh</p>
                    <p class="text-danger-variant-sh mb-0 p-0 ps-2">text-danger-variant-sh</p>
                    <p class="text-gray-strong mb-0 p-0 ps-2">text-gray-strong</p>
                    <p class="text-gray-medium-sh mb-0 p-0 ps-2">text-gray-medium</p>
                    <p class="text-gray-sh mb-0 p-0 ps-2">text-gray-sh</p>
                    <p class="text-gray-hover bg-dark mb-0 p-0 ps-2">text-gray-hover</p>
                    <p class="text-white-sh bg-dark mb-0 p-0 ps-2">text-white-sh</p>
                </div>
            </div>
            <!-- CODIGO QUE SE MUESTRA -->
            <div class="p-3 bg-white" v-highlight><pre class="language-html p-0"><code><script type="text/plain" class="language-markup"><p class="text-primary-sh">text-primary-sh </p>
<p class="text-primary-variant">text-primary-variant</p>
<p class="text-secondary-sh">text-secondary-sh</p>
<p class="text-secondary-variant">text-secondary-variant</p>
<p class="text-tertiary">text-tertiary</p>
<p class="text-tertiary-variant">text-tertiary-variant</p>
<p class="text-siahe bg-dark">text-siahe</p>
<p class="text-surface">text-surface</p>
<p class="text-surface-variant">text-surface-variant</p>
<p class="text-sucess-sh">text-sucess-sh</p>
<p class="text-sucess-variant-sh">text-sucess-variant-sh</p>
<p class="text-warning-sh">text-warning-sh</p>
<p class="text-warning-variant-sh">text-warning-variant-sh</p>
<p class="text-danger-sh">text-danger-sh</p>
<p class="text-danger-variant-sh">text-danger-variant-sh</p>
<p class="text-gray-strong">text-gray-strong</p>
<p class="text-gray-medium-sh">text-gray-medium</p>
<p class="text-gray-sh">text-gray-sh</p>
<p class="text-gray-hover bg-dark">text-gray-hover</p>
<p class="text-white-sh bg-dark">text-white-sh</p>
</script></code></pre>
            </div>
            <!-- CODIGO HTML -->
        </section>
    </div>
</template>
<script>
    export default {
        created(){
        window.scrollTo(0, 0);
    },
    }
</script>
